export default {"src":"/_next/static/media/Kubernetes.8efc2694.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};